import { ApiError, NETWORK_ERROR_CODE, unwrapEnvelope } from "./api";

/**
 * PUT a raw body with upload progress. fetch cannot report upload progress, so this uses XHR.
 * Resolves to `data` of the envelope; `onProgress` receives a fraction from 0 to 1.
 */
export function uploadWithProgress<T>(
  url: string,
  body: Blob,
  onProgress: (fraction: number) => void,
): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("PUT", url);
    xhr.withCredentials = true;
    xhr.setRequestHeader("Accept", "application/json");
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable && event.total > 0) {
        onProgress(event.loaded / event.total);
      }
    };
    xhr.onerror = () => reject(new ApiError(0, NETWORK_ERROR_CODE, "Network error"));
    xhr.onload = () => {
      try {
        resolve(unwrapEnvelope<T>(xhr.status, parseJson(xhr.responseText)));
      } catch (error: unknown) {
        reject(error instanceof Error ? error : new Error(String(error)));
      }
    };
    xhr.send(body);
  });
}

function parseJson(text: string): unknown {
  try {
    return JSON.parse(text) as unknown;
  } catch {
    return null;
  }
}
